/* eslint-disable functional/prefer-tacit */

import { useNavigate as useNavigateActual } from "react-router-dom";

export function useNavigate() {
  return useNavigateActual();
}
